import { assign, invoke, pipe, placeholder } from 'lodash/fp';

import {
  getUid,
} from './getUid';

import {
  ensureUserAndGetIdToken,
} from './ensureUserAndGetIdToken';

export const postDelegatedRequest2 = method => async data =>
{
  const uid = await getUid();
  const idToken = await ensureUserAndGetIdToken();

  const projectId = process.env.VUE_APP_PROJECT_ID;

  const body = pipe
  ([
    assign(placeholder, { idToken, projectId, uid }),
    window.JSON.stringify,
  ])
  (data);

  return window.fetch(
    `https://eatandtrack.herokuapp.com/${ method }`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    },
  )
  .then(invoke('json'));
};